import { render } from "./ComingSoonBanner.vue?vue&type=template&id=0abe359a"
import script from "./ComingSoonBanner.vue?vue&type=script&lang=js"
export * from "./ComingSoonBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__